<template>
	<div class="menu-and-user">
		<ul class="main-menu">
			<li class="has-sub-menu" v-for="menu in menus" v-on:mouseover="menu.active = 1"
			    v-on:mouseleave="menu.active = false" :class="(menu.active) ? 'active' : ''">
				<a href="index.html">
					<div class="icon-w">
						<i :class="'os-icon os-icon-'+menu.icon"></i>
					</div>
				</a>
				<div class="sub-menu-w" v-if="menu.sub">
					<div class="sub-menu-title">
						{{ menu.title }}
					</div>
					<div class="sub-menu-icon">
						<i :class="menu.icon"></i>
					</div>
					<div class="sub-menu-i">
						<ul class="sub-menu">
							<li v-for="(index, sub) in menu.sub">
								<a href="index.html">{{ index.title }}</a>
							</li>
						</ul>
					</div>
				</div>
			</li>
		</ul>
	</div>
</template>

<script>
    export default {
        name: 'dock',
        data () {
            return {
                active: false,
	            userRole: null,
                menus: [
                    {route: '', title: this.$root.t.users, icon: 'os-icon os-icon-grid-circles', active: false },
	                {route: '', title: this.$root.t.users, icon: 'os-icon os-icon-user-male-circle', active: false,
		                sub: [
			                { route: '', title: this.$root.t.user.groups.ROLE_CLIENT, icon: 'tx' },
                            { route: '', title: this.$root.t.user.groups.ROLE_OPERATOR, icon: 'tx' },
                            { route: '', title: this.$root.t.user.groups.ROLE_PERSONAL, icon: 'tx' },
                            { route: '', title: this.$root.t.user.groups.ROLE_ADMIN, icon: 'tx' },
	                ]},
                    {route: '', title: 'AA', icon: 'window-content', active: false,
	                    sub: [
	                        { route: '', title: 'AA', icon: 'tx' }
                    ]}
                ]
            }
        },
	    mounted () {
            this.getMenuType(this.$root.session.user.user_group.group_key);
	    },
        getMenuType: function (Type) {
            switch(Type){
                case 'ROLE_ADMIN':

                    this.menus = [
                        {route: '', title: this.$root.t.users, icon: 'os-icon os-icon-grid-circles', active: false },
                        {route: '', title: this.$root.t.users, icon: 'os-icon os-icon-user-male-circle', active: false,
                            sub: [
                                { route: '', title: this.$root.t.user.groups.ROLE_CLIENT, icon: 'tx' },
                                { route: '', title: this.$root.t.user.groups.ROLE_OPERATOR, icon: 'tx' },
                                { route: '', title: this.$root.t.user.groups.ROLE_PERSONAL, icon: 'tx' },
                                { route: '', title: this.$root.t.user.groups.ROLE_ADMIN, icon: 'tx' },
                            ]},
                        {route: '', title: 'AA', icon: 'window-content', active: false,
                            sub: [
                                { route: '', title: 'AA', icon: 'tx' }
                            ]}
                    ];

                    return this.menus;
                break;
                case 'ROLE_STATION_ADMIN':
                    return 'STATION_ADMIN_PANEL_MAIN_NAVIGATIONS';
                break;
            }
        },
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/dock.vue